<template>
  <div class="fullpage" @contextmenu="onContextMenu">
    <BaseTopBar v-if="isMounted" :with-find="withFind" @find="$emit('find')">
      <template v-if="$slots['topbar-left']" #left>
        <slot name="topbar-left" />
      </template>
      <template #right>
        <slot name="topbar-right" />
      </template>
      <template v-if="$slots['topbar-more']" #more>
        <slot name="topbar-more" />
      </template>
    </BaseTopBar>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";

import BaseTopBar from "@/components/base/BaseTopBar.vue";

export default defineComponent({
  name: "FullPage",
  components: {
    BaseTopBar,
  },
  props: {
    // Forwarded to BaseTopBar: a "Find" entry in the "..." menu and a Mod+F
    // binding, both re-emitted as `find`.
    withFind: { type: Boolean, default: false },
  },
  emits: {
    contextmenu: (_payload: MouseEvent) => true,
    find: () => true,
  },

  setup(_props, { emit }) {
    // Mandatory due to BaseTopBar teleportation
    const isMounted = ref(false);
    onMounted(() => (isMounted.value = true));
    const onContextMenu = (payload: MouseEvent) => emit("contextmenu", payload);
    return {
      isMounted,
      onContextMenu,
    };
  },
});
</script>

<style scoped lang="scss">
.fullpage {
  height: 100%;
  width: 100%;

  .content {
    height: calc(100% - 96px);
    width: calc(100% - 128px);
    padding: 64px 64px 0 64px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
  }
}
</style>
